<template>
  <div class="pkg-search-box">
      <el-form class="pkg-content" :model="dataForm"
               :rules="dataRuleForm"
               ref="dataForm">
        <div class="location-layout">
          <el-row :gutter="0">
            <!-- 课程编号 -->
            <el-col :span="8">
              <el-form-item>
                <div class="link-type">{{ $t('res.rela.courseNumber')}}</div>
                <el-input v-model="dataForm.courseNo"
                          :disabled="true"
                          :placeholder="$t('res.rela.courseNumber')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程状态 -->
            <el-col :span="8">
              <el-form-item :label="$t('res.rela.courseState')"
                            prop="status">
                <el-select v-model="dataForm.status"
                           :disabled="true">
                  <el-option v-for="(item,index) in newcoursestatus"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 课程名称 -->
            <el-col :span="8">
              <el-form-item :label="$t('res.rela.courseName')"
                            prop="coursecName">
                <el-input v-model="dataForm.coursecName"
                          :disabled=disabled
                          :placeholder="$t('res.rela.courseName')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0">
            <!-- 课程时间 -->
            <el-col :span="8">
              <el-form-item :label="$t('res.rela.courseDate')"
                            prop="courseTime">
                <el-input v-model="dataForm.courseTime"
                          :disabled=disabled
                          :placeholder="$t('res.rela.courseDate')"></el-input>
              </el-form-item>
            </el-col>
            <!-- 最大人数 -->
            <el-col :span="8">
              <el-form-item :label="$t('res.cri.maxNo')"
                            prop="maxPersonNo">
                <el-input v-model="dataForm.maxPersonNo"
                          :disabled=disabled
                          :placeholder="$t('res.cri.maxNo')"></el-input>
              </el-form-item>
            </el-col>
            <!-- 最小人数 -->
            <el-col :span="8">
              <el-form-item :label="$t('res.rela.miniPersonNo')"
                            prop="miniPersonNo">
                <el-input v-model="dataForm.miniPersonNo"
                          :disabled=disabled
                          :placeholder="$t('res.rela.miniPersonNo')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0">
            <!-- 课程分类 -->
            <el-col :span="8">
              <el-form-item :label="$t('res.rela.courseClass')"
                            prop="courseClass">
                <el-input v-model="dataForm.classcName"
                          :disabled=disabled
                          :placeholder="$t('res.rela.courseClass')"></el-input>
              </el-form-item>
            </el-col>
            <!-- 团队分类 -->
            <el-col :span="8">
              <el-form-item :label="$t('res.rela.courseTeamClassification')"
                            prop="teamClassification">
                <el-input v-model="dataForm.courseTeamCatalogFirst"
                          :disabled=disabled
                          :placeholder="$t('res.rela.courseTeamClassification')"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </div>
      </el-form>
      <el-form class="pkg-content" :model="dataForms"
               :rules="dataRule"
               ref="dataForms">
        <div class="location-layout">
          <el-row :gutter="0">
            <!-- 车辆数量 -->
            <el-col :span="8">
              <el-form-item :label="$t('res.rela.Number')"
                            prop="number">
                <el-input v-model="dataForms.number"
                          :disabled=disabled
                          :placeholder="$t('res.rela.Number')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="pkg-content">
        <div style="line-height: 20px; margin-top:20px">{{ '说明：1.工位指教室中供放置车辆的位置。' }}</div>
        <div style="line-height: 20px; margin-left:43px">{{ '2.课程所需车辆数量等于工位数量。' }}</div>
        <div style="line-height: 20px; margin-bottom:20px; margin-left:43px ">{{ '3.排课时，每个工位仅选择一辆车辆使用。' }}</div>
        <br>
        <div style="overflow-x: hidden">
          <template v-for="(item, index) in stationList">
            <el-row :key="index"
                    style="margin-bottom: 10px;">
              <el-col :span="24"
                      style=" text-align:left;">
                <!-- 工位备选车辆 -->
                <div class="link-type"
                     @click="handleNodeClick(stationList[index].vehicleInfoList,stationList[index].stationId,index)">{{ $t('res.rela.workstation')}}{{index + 1}}{{ $t('res.rela.altervehicles')}}</div>
                <br>
                <div style="border: 1px;">
                  <el-row style="line-height: 34px">
                    <el-col :span="1"
                            style="min-width: 70px;">
                      <div style="line-height: 34px">{{ $t('res.vehinfo.remark') }}</div>
                    </el-col>
                    <el-col :span="20">
                      <el-input style="display: inline-block;"
                                @blur="changeRemarks(index)"
                                :maxlength="200"
                                v-model="stationList[index].remarks">
                      </el-input>
                    </el-col>
                    <el-col :span="2">
                      <div class="show-or-hide-icon"
                           v-bind:class="{ 'el-icon-arrow-up': item.isShowPartDtlInfo,
                                         'el-icon-arrow-down': !item.isShowPartDtlInfo }"
                           @click="item.isShowPartDtlInfo = !item.isShowPartDtlInfo">&nbsp;{{ item.isShowPartDtlInfo ? '收起' : '展开' }}
                      </div>
                    </el-col>
                  </el-row>
                  <br>
                  <el-row style="border-bottom: 1px solid #b4bccc; margin-bottom: 20px;">
                    <el-table :data="stationList[index].vehicleInfoList"
                              v-show="item.isShowPartDtlInfo"
                              border
                              class="coursevehiclerela-update-pool-table">
                      <el-table-column prop="courseNo"
                                        header-align="center"
                                        type="index"
                                        align="center"
                                        :label="$t('res.rela.label')">
                      </el-table-column>
                      <!-- 主单ID -->
                      <el-table-column prop="gxid"
                                        header-align="center"
                                        align="center"
                                        v-if="false"
                                        width="100"
                                        :label="$t('handle')">
                      </el-table-column>
                      <!-- 工位ID -->
                      <el-table-column prop="stationId"
                                        header-align="center"
                                        align="center"
                                        v-if="false"
                                        width="100"
                                        :label="$t('handle')">
                      </el-table-column>
                      <!-- 课程ID -->
                      <el-table-column prop="courseId"
                                        header-align="center"
                                        align="center"
                                        v-if="false"
                                        width="100"
                                        :label="$t('handle')">
                      </el-table-column>
                      <!-- 车辆ID -->
                      <el-table-column prop="id"
                                        header-align="center"
                                        align="center"
                                        v-if="false"
                                        width="100"
                                        :label="$t('handle')">
                      </el-table-column>
                      <!-- 工位数 -->
                      <el-table-column prop="station"
                                        header-align="center"
                                        align="center"
                                        v-if="false"
                                        width="100"
                                        :label="$t('handle')">
                      </el-table-column>
                      <!-- 车辆底盘号 -->
                      <el-table-column prop="chassisNo"
                                        header-align="center"
                                        align="center"
                                        width="100"
                                        show-overflow-tooltip
                                        :label="$t('res.vehinfo.chassisNo')">
                      </el-table-column>
                      <!-- 车型分类 -->
                      <el-table-column prop="classCnName"
                                        header-align="center"
                                        align="center"
                                        show-overflow-tooltip
                                        :label="$t('res.vehinfo.vehicleClassId')">
                      </el-table-column>
                      <!-- 所属公司 -->
                      <el-table-column prop="companyName"
                                        header-align="center"
                                        align="center"
                                        show-overflow-tooltip
                                        :label="$t('res.vehinfo.companyId')">
                      </el-table-column>
                      <!-- 所属场地 -->
                      <el-table-column prop="siteCnName"
                                        header-align="center"
                                        align="center"
                                        show-overflow-tooltip
                                        :label="$t('res.vehinfo.subordinateSiteId')">
                      </el-table-column>
                      <!-- 当前场地 -->
                      <el-table-column prop="presentSiteName"
                                        header-align="center"
                                        align="center"
                                        show-overflow-tooltip
                                        :label="$t('res.vehinfo.presentSiteId')">
                      </el-table-column>
                      <!-- 车辆分类 -->
                      <el-table-column prop="vehicleClassification"
                                        :formatter="vehicleClassFormatter"
                                        header-align="center"
                                        align="center"
                                        show-overflow-tooltip
                                        :label="$t('res.vehinfo.vehicleClassification')">
                      </el-table-column>
                      <!-- 车辆标签 -->
                      <el-table-column header-align="center"
                                        align="center"
                                        :label="$t('res.vehinfo.label')">
                        <template slot-scope="scope">
                          <!--查看-->
                          <span class="el-dropdown-link"
                                v-if="scope.row.numberLaber !== null"
                                @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
                        </template>
                      </el-table-column>
                      <!-- 优先级 -->
                      <el-table-column prop="priority"
                                        align="center"
                                        :width="130"
                                        :label="$t('res.rela.priority')">
                        <template slot-scope="scope">
                          <div style="line-height: 34px;">
                            <el-select v-model="scope.row.priority" v-if="scope.row.isEdit" class="table-priority-select">
                              <el-option v-for="(item,index) in priorityArr"
                                          :key="index"
                                          :label="item.name"
                                          :value="item.code">
                              </el-option>
                            </el-select>
                            <span v-else>{{ scope.row.priority }}</span>
                          </div>
                        </template>
                      </el-table-column>
                      <!-- 状态 -->
                      <el-table-column prop="status"
                                        :formatter="statusFormatter"
                                        header-align="center"
                                        align="center"
                                        width="90"
                                        show-overflow-tooltip
                                        :label="$t('res.vehinfo.status')">
                      </el-table-column>
                      <!-- 操作 -->
                      <el-table-column fixed="right"
                                        align="center"
                                        width="100"
                                        :label="$t('handle')">
                        <template slot-scope="scope">
                          <span class="table-operate-span" v-if="$hasPermission('AUTHCOURSE0009')&&!scope.row.isEdit" @click="showEditPriority(index, scope.$index)">{{ $t('update') }}</span>
                          <span class="table-operate-span" v-if="$hasPermission('AUTHCOURSE0009')&&scope.row.isEdit" @click="editPriority(scope.row)">{{ $t('save') }}</span>
                          <span class="table-operate-line" v-if="$hasPermission('AUTHCOURSE0009')"></span>
                          <span class="table-operate-span" v-if="$hasPermission('AUTHCOURSE0009')&&!scope.row.isEdit" @click="gotoView('delete', scope.row)">{{ $t('delete') }}</span>
                          <span class="table-operate-span" v-if="$hasPermission('AUTHCOURSE0009')&&scope.row.isEdit" @click="gotDetail">{{ $t('user.back') }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                  <el-row class="btn-position-up pool-operate-buttons" v-if="index !== 0 && $hasPermission('AUTHCOURSE0009')">
                    <el-button type="danger" class="vehiclerela-pool-button" @click="deleteStation(index)">{{ $t('res.rela.delete') }}</el-button>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </template>
          <!-- 新增按钮 -->
          <el-row class="btn-position-up">
            <el-button type="primary"
                       v-if="$hasPermission('AUTHCOURSE0009')"
                       class="vehiclerela-pool-button"
                       @click="insertStation()">{{ $t('res.rela.addPool') }}</el-button>
          </el-row>
        </div>
      </div>
      <br>
      <!-- 按钮区域 -->
      <div class="pkg-content pkg-content-back">
        <el-button type="info"
                   @click="backPage()">{{ $t('res.rela.addreturn') }}</el-button>
      </div>
      <!-- 课程选择页面 -->
      <el-dialog :title="$t('res.rela.alternativeVehicles')"
                 :visible="isShowcour"
                 width="95%"
                 :before-close="courClose">
        <cour-element v-on:couronOk="couronOk"></cour-element>
      </el-dialog>
      <!-- 车辆选择页面 -->
      <el-dialog :title="$t('res.rela.alternativeVehicles')"
                 :visible="isShowsite"
                 width="95%"
                 :before-close="handleClose">
        <menu-element ref="vehicleInfoRef"
                      v-if="isShowsite"
                      :isSelectElection='false'
                      @onOk="onOk"
                      :vehicleInfoList="vehicleInfoList"></menu-element>
      </el-dialog>
      <!-- 标签查看 -->
      <el-dialog title="标签查看"
                 :visible="isShowLable"
                 width="70%"
                 :before-close="showLableClose">
        <el-form label-position="top"
                 label-width="150px"
                 :ref="dataForm"
                 ref="dataForm">
          <div>
            <el-row>
              <el-col :span="24">
                <el-form-item prop="tagName"
                              style="width: 100%!important;">
                  <tag :checkedList="checkList"
                       :moduleId="moduleId"
                       :overLabelShow = "false"
                       :closeShow = "false"
                       :bussinessTypeId = "bussinessTypeId"
                       :brandCode="bussinessTypeChecked"
                       @getBussinessType="getBussinessType"
                       @changeCheckedList="changeCheckedList"
                       ref='tagTree'
                       @fatherMethod="fatherMethod"></tag>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs"
import MenuItem from '@/components/rm/vehicle-info/index'
import CourItem from '@/components/rm/course-choice/index'
import mixinViewModule from '@/mixins/view-module'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  components: {
    Tag,
    'menu-element': MenuItem,
    'cour-element': CourItem
  },
  data () {
    return {
      isShowLable: false,
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 16,
      bussinessTypeChecked: 16,
      visible: false,
      isShowcour: false,
      isShowsite: false,
      isShowResource: false,
      vehicleInfoList: [],
      dataListLoading: false,
      // 课程状态
      newcoursestatus: this.enums['courseStatus'],
      priorityArr: this.enums['priority'], // 优先级
      selectTable: [],
      disabled: true,
      // 选择工位弹出车辆选择框，确认时赋值
      coursevehindex: '',
      stationList: [{ 'remarks': '', 'vehicleInfoList': [] }],
      stationId: '',
      mixinViewModuleOptions: {
        getDataListURL: '/rm/coursevehiclerela/list',
        getDataListIsPage: true,
        deleteURL: '/rm/coursevehiclerela/delete',
        deleteIsBatch: true,
        exportURL: '/rm/coursevehiclerela/export'
      },
      select1: [
        { value: '10', label: 'BBS-50' },
        { value: '20', label: 'BBS-51' },
        { value: '30', label: 'BBS-52' },
        { value: '40', label: 'BBS-53' },
        { value: '50', label: 'H5' },
        { value: '60', label: 'Non TA' }],
      dataForm: {
        courseId: 0,
        courseNo: '',
        status: '',
        coursecName: '',
        courseTime: '',
        maxPersonNo: '',
        miniPersonNo: '',
        classcName: '',
        teamcName: ''
      },
      // 车辆数量默认值
      dataForms: {
        number: 1
      },
      dataRuleForm: {
        courseNo: [
          { required: true, message: this.$t('res.rela.selectCourseNo'), trigger: 'blur' }
        ]
      },
      dataRule: {
        courseId: [
          { required: true, message: '课程id不能为空', trigger: 'blur' }
        ],
        stationId: [
          { required: true, message: '工位id不能为空', trigger: 'blur' }
        ],
        vehicleId: [
          { required: true, message: '车辆id不能为空', trigger: 'blur' }
        ],
        priority: [
          { required: true, message: '优先级不能为空', trigger: 'blur' }
        ],
        creator: [
          { required: true, message: '创建人不能为空', trigger: 'blur' }
        ],
        createdDate: [
          { required: true, message: '创建时间不能为空', trigger: 'blur' }
        ],
        modifier: [
          { required: true, message: '修改人不能为空', trigger: 'blur' }
        ],
        lastUpdatedDate: [
          { required: true, message: '上次修改时间不能为空', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '版本号不能为空', trigger: 'blur' }
        ]
      },
      stationIndex: '',
      nowEdit: false,
      addPoolList: []
    }
  },
  mounted () {
    this.queryDataList()
    this.$eventHub.$on(this.GLOBAL.COURSE_VEHICALERELA, () => {
      this.queryDataList()
    })
  },
  methods: {
    gotoView (type, row) {
      if (type === 'delete') {
        this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }).then(() => {
          const param = {
            id: row.gxid,
            courseId: row.courseId,
            stationId: row.stationId
          }
          this.$request.post('/rm/coursevehiclerela/vehicleDelete', param).then(() => {
            this.nowEdit = false
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success'
            })
            this.queryDataList()
          })
        })
      }
    },
    gotDetail () {
      this.queryDataList()
    },
    // 展示编辑功能
    showEditPriority (bindex, index) {
      if (!this.nowEdit) {
        const obj = Object.assign(this.stationList[bindex].vehicleInfoList[index], { isEdit: true })
        this.$set(this.stationList[bindex].vehicleInfoList, index, obj)
        this.nowEdit = true
      } else {
        this.$message({
          message: this.$t('res.courseclassroomrela.needSave'),
          type: 'warning'
        })
      }
    },
    queryDataList () {
      this.$nextTick(() => {
        this.dataForm.courseId = this.$route.query.courseId
        this.getInfo()
      })
    },
    // 加载页面时赋值
    getInfo () {
      this.$request.get(`/rm/coursevehiclerela/editor/${this.dataForm.courseId}`).then((data) => {
        this.nowEdit = false
        this.dataForm.courseNo = data.courseNo
        this.dataForm.status = data.status
        this.dataForm.coursecName = data.coursecName
        this.dataForm.courseTime = data.courseTime
        this.dataForm.maxPersonNo = data.maxPersonNo
        this.dataForm.miniPersonNo = data.miniPersonNo
        this.dataForm.classcName = data.classcName
        this.dataForm.courseTeamCatalogFirst = data.courseTeamCatalogSecond
        let courseTeamCatalogName = ''
        this.select1.forEach(iteam => {
          if (iteam.value === data.courseTeamCatalogFirst) {
            courseTeamCatalogName = iteam.label + ',' + data.courseTeamCatalogSecond
          }
        })
        this.dataForm.teamcName = courseTeamCatalogName
        this.dataForms.number = data.courseStationObj.length
        for(let item of data.courseStationObj) {
          item.isShowPartDtlInfo = true
        }
        this.stationList = data.courseStationObj.map((item) => {
          item.vehicleInfoList = item.vehicleInfoList.map((i) => {
            return { ...i, isEdit: false }
          })
          return item
        })
      })
    },
    insertStation () {
      this.stationList.push({ 'remarks': '', 'isShowPartDtlInfo': true, 'vehicleInfoList': [] })
      this.dataForms.number = this.stationList.length
    },
    // 移除
    deleteStation (index) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('res.courseclassroomrela.remove') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.nowEdit = false
        if (this.stationList[index].vehicleInfoList.length > 0) {
          const obj = this.stationList[index].vehicleInfoList[0]
          const param = {
            courseId: obj.courseId,
            stationId: obj.stationId
          }
          this.$request.post('/rm/coursevehiclerela/deleteL', param).then(() => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success'
            })
          })
          this.stationList.splice(index, 1)
          this.dataForms.number = this.stationList.length
        } else {
          this.$nextTick(() => {
            this.stationList.splice(index, 1)
            this.dataForm.number = this.stationList.length
          })
        }
      })
    },
    // 车辆分类转换
    vehicleClassFormatter (row) {
      return Vue.filter('coverEnum')(row.vehicleClassification, 'vehicleClass')
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    // 车辆选择弹出页面事件
    handleNodeClick (vehicleInfoList, id, index) {
      this.stationId = id
      this.vehicleInfoList = vehicleInfoList
      this.courseId = this.dataForm.courseId
      this.stationIndex = index
      this.coursevehindex = index
      this.isShowsite = true
      this.$nextTick(() => {
        this.$refs.vehicleInfoRef && this.$refs.vehicleInfoRef.initMethods()
      })
    },
    // 车辆选择关闭页面事件
    handleClose () {
      this.isShowsite = false
    },
    // 课程选择关闭页面事件
    courClose () {
      this.isShowcour = false
    },
    couronOk (select) {
      let _this = this
      _this.dataForm = select
      this.isShowcour = false
    },
    onOk (vehicleData) {
      this.addPoolList = []
      vehicleData.forEach((item) => {
        this.$set(item, 'updateDate', dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'))
        this.$set(item, 'isEdit', false)
        this.stationList[this.coursevehindex].vehicleInfoList.push(item)
      })
      this.addPoolList = vehicleData
      const param = {
        courseId: this.courseId,
        stationId: this.stationId,
        remarks: this.stationList[this.coursevehindex].remarks,
        station: this.coursevehindex,
        selectList: this.addPoolList
      }
      this.$request.post('/rm/coursevehiclerela/enditSave', param).then(() => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success'
        })
        this.queryDataList()
        this.isShowsite = false
      })
    },
    editPriority (row) {
      if (!row.priority) {
        this.$message.warning(this.$t('res.rela.selectPriority'))
        return false
      }
      let url = ''
      let param = ''
      url = `/rm/coursevehiclerela/update`
      param = {
        id: row.gxid,
        courseId: this.courseId,
        vehicleId: this.vehicleId,
        station: this.station,
        priority: row.priority
      }
      this.$request.post(
        url,
        param
      ).then((data) => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success'
        })
        this.queryDataList()
      })
    },
    backPage () {
      for(let i of this.stationList) {
        for(let j of i.vehicleInfoList) {
          if (j.isEdit) {
            this.$confirm(this.$t('res.courseclassroomrela.cancelinfo'), this.$t('prompt.title'), {
              confirmButtonText: this.$t('confirm'),
              cancelButtonText: this.$t('cancel'),
              type: 'warning'
            }).then(() => {
              this.$router.go(-1)
            })
            return false
          }
        }
      }
      this.$router.go(-1)
    },
    checkLable(row){
      this.checkList = []
      this.isShowLable = true
      this.$request.get(`/rm/vehicleinfo/info/${row.id}`).then((data) => {
        // 已选择的标签
        this.checkList = data.commLabelVoList ? data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          this.checkList = this.checkList.map((item) => {
            Object.assign(item, { labelName: item.labelNameCn })
            return
          }).filter((item) => item.labelName)
        } else {
          this.checkList = this.checkList.map((item) => {
            Object.assign(item, { labelName: item.labelNameEn })
            return
          }).filter((item) => item.labelName)
        }
      })
    },
    showLableClose(){
      this.isShowLable = false
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = 16
      this.bussinessTypeId = 16
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    changeRemarks (index) {
      const stationId = this.stationList[index].vehicleInfoList.length > 0 ? this.stationList[index].vehicleInfoList[0].stationId : ''
      if (!stationId) {
        this.$message({
          message: this.$t('res.coursetrainerrela.remarkChange3'),
          type: 'warning'
        })
        return false
      }
      const params = {
        courseId: this.dataForm.courseId,
        stationList: [{ stationId: stationId, remarks: this.stationList[index].remarks }]
      }
      this.$request.post('/rm/coursevehiclerela/stationUpdate', params).then((res, total, code, data) => {
        if (data.msg === 'success') {
          this.$message({
            message: this.$t('res.coursetrainerrela.remarkChangeSuccss'),
            type: 'success'
          })
        }
      })
    },
    // 重新勾选业务标签
    fatherMethod () {
      // 已选择的标签
      this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList = this.checkList.map((item) => {
          Object.assign(item, { labelName: item.labelNameCn })
          return
        }).filter((item) => item.labelName)
      } else {
        this.checkList = this.checkList.map((item) => {
          Object.assign(item, { labelName: item.labelNameEn })
          return
        }).filter((item) => item.labelName)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.postion {
  color: blue;
}
.postion:hover {
  outline: none;
  border-bottom: 1px solid blue;
}
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
.pkg-search-box {
  color: #303133;
  transition: 0.3s;
  border-radius: 4px;
  overflow: hidden;
}
.pkg-content {
  background-color: #fff;
  padding: 20px;
  &.pkg-content-back {
    text-align: right;
  }
}
.course-update-button {
  padding: 8px 20px !important;
  border-left: none !important;
}
.pool-operate-buttons {
  text-align: right;
  margin-bottom: 10px;
}
.vehiclerela-pool-button {
  cursor: pointer;
  &.el-button--danger {
    &:hover,&:active {
      color: #fff;
      background-color: #f78989 !important;
      border-color: #f78989 !important;
      opacity: .8;
    }
  }
}
.coursevehiclerela-update-pool-table {
  .table-priority-select {
    text-align: center !important;
    .el-input__inner {
      text-align: center !important;
    }
  }
  .table-operate-line {
    display: inline-block;
    width: 1px;
    background-color: #409eff;
    height: 14px;
    line-height: 23px;
    margin: 0 8px;
    vertical-align: middle;
  }
  .table-operate-span {
    display: inline-block;
    color: #409eff;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      opacity: .8;
    }
  }
}
</style>